export const defaultPlaceholder = {
  303: {
    name: 'IP名字_IP Schedule',
    file: 'ProjectName_IP_Schedule_BrandName_NORMCORE_20180305_V1',
    desc: '本Schedule包含\n 1. IP代理项目的谈判时间节奏，包含权益落实、签署合同、付款等',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  302: {
    name: 'IP名字_IP Plan',
    file: 'ProjectName_Proposal_BrandName_NORMCORE_20180305_V1',
    desc: `本次IP策划的内容包含：\n1. IP策略\n2. IP推荐清单`,
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  434: {
    file: 'ProjectName_KOL_Proposal_BrandName_NORMCORE_20180305_V1',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  306: {
    name: '媒体名称（若需）_Media Schedule',
    file: 'ProjectName_Media_Schedule_BrandName_NORMCORE_20180305_V1',
    desc: `本Schedule包含以下项目的时间表：\n
Media策划与提案、Master plan、Spotplan、上线、下线、Postbuy`,
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  305: {
    name: '媒体类别（比如digital/traditional/整合）_Media Plan',
    file: 'ProjectName_Media_Proposal_BrandName_NORMCORE_20180305_V1',
    desc: '本策划工作包含：\n' +
    '媒介目标\n' +
    '媒介策略\n' +
    '媒体选择\n' +
    '内容选择\n' +
    '形式选择\n' +
    '时间进度规划\n' +
    '预算分配\n' +
    '效果预估',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },

  307: {
    name: '请写上具体的任务名称',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  4: {
    name: 'Project Schedule',
    file: 'ProjectName_Content_Schedule_BrandName_NORMCORE_20180305_V1',
    desc: '本Schedule包含\n' +
    '1. 项目的策划创意的前期提案时间安排\n' +
    '2. 项目中创意产出部分的时间安排\n' +
    '3. 可以合并技术、媒体、IP等时间表',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  6: {
    name: 'Project Spotplan',
    file: 'ProjectName_Content_Spotplan_BrandName_NORMCORE_20180305_V1',
    desc: '本Spotplan工作包含\n' +
    '1. Social部分的内容排列\n' +
    '2. 合并媒体/KOL/IP等内容\n' +
    '3. 媒体MR的内容排列',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  1: {
    name: '项目名称_Proposal',
    file: 'ProjectName_Content_Proposal_BrandName_NORMCORE_20180305_V1',
    desc: '"本策划工作需要包含：\n' +
    '1. Objective(此次的目的)\n' +
    '2.市场分析（自身/竞品/环境）\n' +
    '3.策略（品牌定位/传播/媒介/IP/KOL）\n' +
    '4.IP Insight（IP洞察）\n' +
    '5.TA Insight（受众洞察）\n' +
    '6. 核心创意（Core Idea)\n' +
    '7. 执行创意（Execution Idea）\n' +
    '8. Calendar\n' +
    '9. Manpower\n' +
    '10. Quotation"',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  9: {
    name: '实现任务（如H5/App/Website）_Tech Schedule',
    file: 'ProjectName_Tech_Schedule_BrandName_NORMCORE_20180305_V1',
    desc: '本Schedule包含：\n' +
    '1. 项目需求调研\n' +
    '2. 原型图\n' +
    '3. UI\n' +
    '4. 开发\n' +
    '5. 测试\n' +
    '6. 上线与下线',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  11: {
    name: '项目名称_Tech Proposal',
    file: 'ProjectName_Tech_Proposal_BrandName_NORMCORE_20180305_V1',
    desc: '本项目策划书包含 - \n' +
    '1. 用户体验流程（Userflow）\n' +
    '2. 功能结构 （Function Module）\n' +
    '3. 主要功能的展示（Mock Up）',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  12: {
    name: '实现任务（如H5/App/Website）_UI制作',
    file: 'ProjectName_UI_BrandName_NORMCORE_20180305_V1',
    desc: '请描述出客户指定的字体，邀请执行者制作符合proposal的UI',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  13: {
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  14: {
    file: 'ProjectName_Wireframe_BrandName_NORMCORE_20180305_V1',
    desc: '原型图设计中包含以下内容：\n' +
    '1. 功能细节展示\n' +
    '2. 页面结构布局以及跳转流程\n' +
    '3. 页面文案',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  308: {
    file: 'ProjectName_Data_Schedule_BrandName_NORMCORE_20180305_V1',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  311: {
    name: '客户名_项目名_Dashboard需求（日报/周报/月报）',
    file: 'ProjectName_Dashboard_Template_NORMCORE_20180305_V1(Template若为客户模板保留，非客户模板则删除）',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  312: {
    file: 'ProjectName_Prop_Schedule_BrandName_NORMCORE_20180305_V1',
    desc: '与供应商check如下时间表：\n' +
    '打样周期\n' +
    '大货制作周期\n' +
    '物流周期',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  16: {
    name: '项目名称_供应商名称_具体内容（比如：视频制作，拍摄等）_合同金额',
    file: '合同ID_项目名称_供应商名称_具体内容（比如：视频制作，拍摄等）_合同金额',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  19: {
    name: '客户_项目名称_报价单编号_报价单价格',
    file: '客户_项目名称_报价单编号_报价单价格',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  20: {
    name: '项目名称_供应商名称_打款金额',
    file: '项目名称_供应商名称_打款金额',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  17: {
    name: '客户_项目名称_金额_版本（v1，v2…)',
    file: '报价单ID_客户_项目名称_金额_版本（v1，v2…)',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  },
  18: {
    name: 'yyyymm报销（例：201809报销）',
    file: '"1. 项目报销：项目名称（自动获取）_费用类别\n' +
    '2. 行政报销：部门_员工姓名（中文）_费用类别"',
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '不予报销情况：\n' +
    '1. 违章罚款；\n' +
    '2. 报销凭证不符合规定；\n' +
    '3. 无理由跨年度的单据。'
  },
  default: {
    quality: '请务必输入质检不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进。2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。',
    audit: '请务必输入审核不通过的具体理由，将作为管理者的一项基本考核，请遵守反馈三原则：1. 高度具体。具体到本事物如何开展推进；2. 引导思考。包含超越当前项目的建议，其中包含的智慧可以给未来的项目带来帮助。3.鼓舞人心。尽管是反馈与意见，请注意语言与用词，勿使创作者失去信心而放弃。'
  }
}
